<template>
    <li class="nav-item dropdown ">
        <a class="nav-link" data-toggle="dropdown" href="#">
            <i class="far fa-user-circle"></i>
            <span class="badge badge-danger navbar-badge" v-if="onlinecustomers.length>0">{{onlinecustomers.length}}</span>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right notpop" >
            <span v-for="enquiry in onlinecustomers">
                <a href="#" class="dropdown-item bg-warning" @click="viewenquiry(enquiry.encryptedid)">

                            <div class="media">

                                <div class="media-body">
                                    <h3 class="dropdown-item-title">
                                        {{ Online }}

                                        <small class="text-muted float-right" > {{ dateTime(enquiry.customer_online_at)}}</small>

                                    </h3>
                                    <p class="text-sm">CDM{{ enquiry.id }} - {{ enquiry.name }}</p>

                                </div>
                            </div>

                        </a>
                        <div class="dropdown-divider"></div>
            </span>


        </div>
    </li>
    <li class="nav-item dropdown notpop">
        <a class="nav-link" data-toggle="dropdown" href="#">
            <i class="far fa-bell"></i>
            <span class="badge badge-danger navbar-badge" v-if="notifications.length>0">{{notifications.length}}</span>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right notpop" >
            <span v-for="notification in notifications">
                <a href="#" class="dropdown-item bg-warning" @click="viewnoti(notification.id)">

                            <div class="media">

                                <div class="media-body">
                                    <h3 class="dropdown-item-title">
                                        {{ notification.title}}

                                        <small class="text-muted float-right" > {{ notification.created_at}}</small>

                                    </h3>
                                    <p  class="text-sm">{{ notification.desc }}</p>

                                </div>
                            </div>

                        </a>
                        <div class="dropdown-divider"></div>
            </span>


        </div>
    </li>


    <div @click="isOpen=true" v-if="alerts.length>0" class="alerts-item animate__animated animate__slow animate__bounce animate__infinite	infinite"  style="--animate-duration:5s" data-widget="control-sidebar" data-controlsidebar-slide="true" href="#" role="button">
        <span class="alerts-badge">{{alerts[0]['title']}}</span>
        <span class="alerts-icon"><i class="fa-solid fa-bell"></i></span>

    </div>

    <aside ref="sidebar" class="control-sidebar control-sidebar-dark" v-if="isOpen">
        <div class="title">
            Alerts
            <span @click="hidebar">
                <i class="fa-solid fa-circle-xmark"></i>
            </span>
        </div>
        <ul>
            <li v-for="notification in alerts">
                <a  href="#" class="bg-warning" @click="viewenquiry(notification.eid)">

                    <div class="media">

                        <div class="media-body">
                            <h3 class="dropdown-item-title">
                                {{ notification.title}}

                                <small class="text-muted float-right" > {{ notification.date}}</small>

                            </h3>
                            <p class="text-sm">CDM{{ notification.id }} - {{ notification.name }}</p>

                        </div>
                    </div>

                </a>
            </li>
        </ul>
    </aside>

</template>

<script>
import moment from 'moment';
import { notify } from "@kyvg/vue3-notification";
export default {
    name: "NotificationBox",
    components: {

    },
    data() {
        return {
            loading: false,
            lastnotificationid:null,
            notifications:[],
            onlinecustomers:[],
            websocketconnection: null,
            alerts:[],
            isOpen:false
        }
    },
    mounted() {
        this.getdata();
        setInterval(() => {
            this.getdata();
        }, 60000)
       // this.shownotification();
       // this.opensocketconn();
    },
    methods: {
        dateTime(value) {
            return moment(value).format('DD MMM YY LT');
        },
        getdata() {
            let currentObj = this;
            this.loading = true;
            axios.get('/getnotifications').then(function (response) {
                currentObj.notifications = response.data.notifications;
                currentObj.onlinecustomers = response.data.onlinecustomers;
                currentObj.alerts = response.data.alerts;
                currentObj.loading = false;
                var templast='';
                currentObj.notifications.forEach((value, index) => {
                    if(templast==''){
                        templast=value.id;
                    }

                    if(value.notified==0){
                        const notification = {
                            title: value.title,
                            options: {
                                body: value.desc,
                            },
                            events: {
                                onclick: function () {
                                    currentObj.viewnoti(value.id)
                                }
                            },
                        }
                        currentObj.$notification.show(
                            notification.title,
                            notification.options,
                            notification.events,
                        )
                    }

                });

                if(currentObj.lastnotificationid!=null && templast!='' && currentObj.lastnotificationid!==templast){

                   // $('.notpop').addClass('show');
                }
                currentObj.lastnotificationid=templast;

            })
                .catch(function (error) {
                    currentObj.loading = false;
                });
        },
        shownotification(){
            notify({
                position:"top right",
                title: "Vue 3 notification 🎉",
            });
        },
        opensocketconn(){
            console.log("Starting connection to WebSocket Server")
            this.websocketconnection = new WebSocket("wss://echo.websocket.org")

            this.websocketconnection.onmessage = function(event) {
                console.log(event);
            }

            this.websocketconnection.onopen = function(event) {
                console.log(event)
                console.log("Successfully connected to the echo websocket server...")
            }
        },
        viewnoti(id){
            window.open('/viewnotification?id='+id, "_blank", "width="+screen.availWidth+",height="+screen.availHeight)

        },
        viewenquiry(id){
            window.open('/viewenquiry?id='+id, "_blank", "width="+screen.availWidth+",height="+screen.availHeight)
        },
        hidebar(){
            this.isOpen=false
        }
    }
}
</script>

<style scoped>

</style>
